/**
 * Телефон в ЕДИНОМ виде: `+7 914 928-69-66`.
 *
 * Номера заносят как придётся: кто-то с восьмёрки и слитно, кто-то с плюсом и
 * дефисами, кто-то со скобками. К сентябрю 2026-го в справочнике врачей
 * набралось три разных написания одного и того же формата — и список перестал
 * читаться столбиком: глаз ищет код оператора там, где у соседа уже номер.
 *
 * Приведение делается по цифрам, а не по строке: из записи выбрасывается всё,
 * кроме цифр, и собирается заново. Поэтому годится любой ввод — «8 914 928 69
 * 66», «+7(914)9286966», «89149286966» дают один и тот же результат.
 *
 * ЧУЖОЕ НЕ ТРОГАЕМ. Если цифр не десять и не одиннадцать или номер не
 * российский, запись остаётся как есть: лучше непривычный вид, чем испорченный
 * иностранный номер или обрезанный внутренний.
 */
/** Российский номер к виду `+7 914 928-69-66`; прочее — без изменений. */
export function formatPhone(raw) {
    const исходный = (raw ?? '').trim();
    const цифры = исходный.replace(/\D/g, '');
    /*
     * «8 914…» и «7 914…» — один номер: восьмёрка досталась от городской
     * привычки набирать межгород. Десять цифр — номер без кода страны.
     */
    const полный = цифры.length === 11 && (цифры.startsWith('7') || цифры.startsWith('8'))
        ? `7${цифры.slice(1)}`
        : цифры.length === 10
            ? `7${цифры}`
            : null;
    if (!полный)
        return исходный;
    return `+7 ${полный.slice(1, 4)} ${полный.slice(4, 7)}-${полный.slice(7, 9)}-${полный.slice(9, 11)}`;
}
//# sourceMappingURL=phone.js.map